import type { Monaco } from "@monaco-editor/react";

const DARK_RULES = [
  { token: "comment", foreground: "6A9955", fontStyle: "italic" },
  { token: "keyword", foreground: "C586C0" },
  { token: "string", foreground: "CE9178" },
  { token: "number", foreground: "B5CEA8" },
  { token: "type", foreground: "4EC9B0" },
  { token: "class", foreground: "4EC9B0" },
  { token: "function", foreground: "DCDCAA" },
  { token: "variable", foreground: "9CDCFE" },
  { token: "regexp", foreground: "D16969" },
];

const DARK_COLORS = {
  "editor.background": "#0C1220",
  "editor.foreground": "#D4D4D4",
  "editorCursor.foreground": "#E94D1D",
  "editor.selectionBackground": "#E94D1D55",
  "editor.inactiveSelectionBackground": "#E94D1D33",
  "editor.selectionHighlightBackground": "#E94D1D38",
  "editor.wordHighlightBackground": "#E94D1D28",
  "editor.wordHighlightStrongBackground": "#E94D1D40",
  "editor.lineHighlightBackground": "#E94D1D12",
  "editorLineNumber.foreground": "#5C6B8A",
  "editorLineNumber.activeForeground": "#E94D1D",
  "editorIndentGuide.background": "#2A3448",
  "editorIndentGuide.activeBackground": "#E94D1D44",
  "editorBracketMatch.background": "#E94D1D33",
  "editorBracketMatch.border": "#E94D1D88",
  "minimap.background": "#0C1220",
  "scrollbarSlider.background": "#E94D1D33",
  "scrollbarSlider.hoverBackground": "#E94D1D55",
  "scrollbarSlider.activeBackground": "#E94D1D77",
};

/**
 * `EX-PUB21`: the Judge's editor sits on the Judge bar's own near-black
 * instead of the Playground's navy (finding 14 of the "Judge pages"
 * proposal). Monaco takes colours only as strings, so the three neutrals are
 * written here as the values of the Tailwind tokens they are (`neutral-950`,
 * `neutral-500`, `neutral-800` in `tailwind.config.ts`); everything else is the
 * Playground theme unchanged.
 */
const JUDGE_GROUND = {
  "editor.background": "#0B0B0C",
  "minimap.background": "#0B0B0C",
  "editorLineNumber.foreground": "#666666",
  "editorIndentGuide.background": "#1F1F1F",
};

/** Custom dark theme — docs/24_PLAYGROUND_SPEC.md §10.7. The Judge's variant is registered beside it. */
export function registerProgsityDarkTheme(monaco: Monaco): void {
  monaco.editor.defineTheme("progsity-dark", {
    base: "vs-dark",
    inherit: true,
    rules: DARK_RULES,
    colors: DARK_COLORS,
  });
  monaco.editor.defineTheme("progsity-judge", {
    base: "vs-dark",
    inherit: true,
    rules: DARK_RULES,
    colors: { ...DARK_COLORS, ...JUDGE_GROUND },
  });
}
